import {Vector3} from "three";
import convertDegreesToRadians from "./convertDegreesToRadians";
import getPointInBetweenByLen from "./getPointInBetweenByLen";

function rotatePointAroundPoint (pointA: Vector3, pointB: Vector3, deg: number): Vector3 {
    const centerXY = getPointInBetweenByLen(pointA, pointB)
    const newX = centerXY.x + (pointB.x-centerXY.x)*Math.cos(convertDegreesToRadians(deg)) - (pointB.z-centerXY.z)*Math.sin(convertDegreesToRadians(deg));
    const newZ = centerXY.z + (pointB.x-centerXY.x)*Math.sin(convertDegreesToRadians(deg)) + (pointB.z-centerXY.z)*Math.cos(convertDegreesToRadians(deg));
    return new Vector3(newX, pointA.y, newZ)
}

export default rotatePointAroundPoint
